import { TEXT_STRING } from '../../constants';
import { TSearchShelfCard, TSearchShelfJobGroup } from 'types';

export type JobShelfRowConfig = {
  group: TSearchShelfJobGroup;
  title: string;
  icon: 'building' | 'user' | 'groupUser';
};

export const JOB_SHELF_ROWS: JobShelfRowConfig[] = [
  {
    group: 'BRAND',
    title: TEXT_STRING.SEARCH_PAGE.JOB_GROUP_BRAND,
    icon: 'building',
  },
  {
    group: 'STAFF',
    title: TEXT_STRING.SEARCH_PAGE.JOB_GROUP_STAFF,
    icon: 'user',
  },
  {
    group: 'COMMUNITY',
    title: TEXT_STRING.SEARCH_PAGE.JOB_GROUP_COMMUNITY,
    icon: 'groupUser',
  },
];

export type JobShelfRowWithCards = JobShelfRowConfig & {
  cards: TSearchShelfCard[];
};

export function getVisibleJobShelfRows(
  cards: TSearchShelfCard[],
): JobShelfRowWithCards[] {
  return JOB_SHELF_ROWS.map((row) => ({
    ...row,
    cards: cards.filter((card) => card.jobGroup === row.group),
  })).filter((row) => row.cards.length > 0);
}

export function hasVisibleJobShelfCards(cards: TSearchShelfCard[]): boolean {
  return getVisibleJobShelfRows(cards).length > 0;
}
